module.exports = "<stations-page></stations-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/stations.html
// module id = 1380
// module chunks = 0